document.documentElement.classList.remove('no-js');
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cart-open]');
      if (trigger) {
        event.preventDefault();
        this.open();
      }
    });
    this.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => this.close()));
    this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
  }
  open() { this.dialog?.showModal(); document.body.classList.add('drawer-open'); }
  close() { this.dialog?.close(); document.body.classList.remove('drawer-open'); }
}
customElements.define('cart-drawer', CartDrawer);
class ProductGallery extends HTMLElement {
 connectedCallback(){this.track=this.querySelector('.product-gallery__track');this.slides=[...this.querySelectorAll('[data-media-slide]')];this.dots=[...this.querySelectorAll('[data-media-dot]')];this.thumbnails=[...this.querySelectorAll('[data-media-thumb]')];this.index=0;this.thumbnails.forEach((thumbnail,i)=>thumbnail.addEventListener('click',()=>this.show(i)));this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i)));this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.show(this.index+1));this.track?.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.update();},{passive:true});}
 update(){this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));this.thumbnails.forEach((thumbnail,i)=>thumbnail.setAttribute('aria-current',String(i===this.index)));const active=this.thumbnails[this.index],strip=active?.parentElement;if(active&&strip&&strip.clientWidth&&this.lastThumbnailIndex!==this.index){this.lastThumbnailIndex=this.index;const item=active.getBoundingClientRect(),frame=strip.getBoundingClientRect();if(item.left<frame.left||item.right>frame.right)strip.scrollTo({left:strip.scrollLeft+item.left-frame.left-(strip.clientWidth-item.width)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}}
 show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.update();}
 showMedia(id){const i=this.slides.findIndex(slide=>slide.dataset.mediaId===String(id));if(i>=0)this.show(i);}
}
customElements.define('product-gallery',ProductGallery);

const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const editorialVideos = [...document.querySelectorAll('video[data-autoplay-media]')];
const setVideoMotion = () => {
  editorialVideos.forEach(video => {
    if (motionQuery.matches) video.pause();
  });
};
if ('IntersectionObserver' in window && !motionQuery.matches) {
  const videoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    });
  }, { rootMargin: '100px 0px', threshold: 0.2 });
  editorialVideos.forEach(video => videoObserver.observe(video));
}
setVideoMotion();
motionQuery.addEventListener?.('change', setVideoMotion);

document.querySelectorAll('[data-product-root]').forEach(root=>{
 const variantSelect=root.querySelector('[data-variant-select]'),json=root.querySelector('[data-cs-variants]'),options=[...root.querySelectorAll('[data-option-dropdown]')];if(!variantSelect||!json||!options.length)return;
 let variants;try{variants=JSON.parse(json.textContent);}catch{return;}
 const form=document.getElementById(variantSelect.getAttribute('form')),add=form?.querySelector('[data-add-button]'),status=root.querySelector('[data-option-status]'),checkout=root.querySelector('[data-dynamic-checkout]');
 const customCords=[...root.querySelectorAll('[data-custom-cord]')];
 const customReady=()=>customCords.every(select=>Boolean(select.value));
 const choices=()=>options.map(select=>select.value);
 const selectedVariant=()=>{const values=choices();return values.every(Boolean)?variants.find(v=>v.options.every((value,i)=>value===values[i])):undefined;};
 const names=options.map(o=>o.dataset.optionName.toLowerCase());
 const hint=status?.dataset.customHint||(names.includes('shade')&&names.includes('finish')?'Select a shade and finish to continue.':`Select ${names.join(' and ')} to continue.`);
 const update=()=>{
  const chosen=choices();
  options.forEach((select,index)=>[...select.options].forEach(option=>{
    if(!option.value)return;
    const matching=variants.filter(variant=>variant.options[index]===option.value&&chosen.every((value,otherIndex)=>otherIndex===index||!value||variant.options[otherIndex]===value));
    const inStock=matching.some(variant=>variant.available);
    const suffix=!matching.length?' — Unavailable with selected options':!inStock?' — Out of stock':location.pathname.includes('/products/love-coin-necklace')?' — In stock':'';
    option.textContent=option.value+suffix;
    option.disabled=!matching.length;
  }));
  const shadeIndex=options.findIndex(select=>select.dataset.optionName?.toLowerCase()==='shade');
  if(shadeIndex>=0&&chosen[shadeIndex]&&!chosen.every(Boolean)){
   const candidates=variants.filter(candidate=>candidate.options[shadeIndex]===chosen[shadeIndex]);
   const preview=candidates.find(candidate=>candidate.available&&candidate.featured_media)||candidates.find(candidate=>candidate.featured_media);
   if(preview?.featured_media?.id)root.querySelector('product-gallery')?.showMedia(preview.featured_media.id);
  }
  const variant=selectedVariant();variantSelect.value=variant?String(variant.id):'';const ready=Boolean(variant?.available)&&customReady();
  if(add){add.disabled=!ready;add.textContent=variant&&!variant.available?add.dataset.soldText:add.dataset.addText;}
  if(checkout)checkout.hidden=!ready;
  if(status){const missing=options.filter(select=>!select.value).map(select=>select.dataset.optionName.toLowerCase());const remaining=missing.length===1?(status.dataset.remainingTemplate||'Select your __OPTION__ to continue.').replace('__OPTION__',missing[0]):hint;status.textContent=choices().every(Boolean)&&customReady()?(ready?'':variant?'This combination is sold out.':'This combination is unavailable.'):(customCords.length&&!customReady()?hint:remaining);status.hidden=ready;}
  const stock=root.querySelector('[data-variant-stock]'),stockOption=variant?[...variantSelect.options].find(o=>o.value===String(variant.id)):null;
  if(stock){const message=ready?stockOption?.dataset.lowStock||'':'';stock.textContent=message;stock.hidden=!message;}
  if(variant){const option=[...variantSelect.options].find(o=>o.value===String(variant.id));const price=root.querySelector('[data-product-price]');if(price&&option)price.textContent=option.dataset.price;if(option?.dataset.mediaId)root.querySelector('product-gallery')?.showMedia(option.dataset.mediaId);const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
 };
 [...options,...customCords].forEach(select=>select.addEventListener('change',update));
 form?.addEventListener('submit',event=>{if(!selectedVariant()?.available||!customReady()){event.preventDefault();form.reportValidity();}});update();
});




class CollectionControls extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    this.updatePieceCount();
    this.querySelector('[data-filter-open]')?.addEventListener('click', () => dialog.showModal());
    this.querySelector('[data-filter-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    const form = dialog.querySelector('form');
    form?.addEventListener('change', event => {
      if (event.target.matches('input[type="checkbox"], select, input[type="number"]')) form.requestSubmit();
    });
    form?.addEventListener('submit', event => {
      const inputs = [...event.target.querySelectorAll('input[type="number"]')];
      const [min, max] = inputs;
      if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
        event.preventDefault();
        min.focus();
        return;
      }
      inputs.forEach(input => { if (!input.value) input.disabled = true; });
    });
  }
  async updatePieceCount() {
    const output = this.querySelector('[data-piece-count]');
    if (!output || (Number(output.dataset.page) === 1 && Number(output.dataset.pages) <= 1)) return;
    const url = new URL(output.dataset.collectionUrl, location.origin);
    url.search = location.search;
    url.searchParams.set('view', 'piece-count');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    let total = 0;
    try {
      for (let page = 1, pages = 1; page <= pages; page++) {
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection count unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const count = html.querySelector('[data-piece-count]');
        if (!count || Number(count.dataset.page) !== page) throw new Error('Incomplete collection count');
        const value = Number(count.dataset.count);
        pages = Number(count.dataset.pages) || 1;
        if (!Number.isSafeInteger(value) || value < 0 || !Number.isSafeInteger(pages)) throw new Error('Invalid collection count');
        total += value;
      }
      output.textContent = output.dataset.label.replace('__COUNT__', String(total));
      output.hidden = false;
    } catch {
      output.hidden = true;
    }
  }
}
customElements.define('collection-controls', CollectionControls);
class CardCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const track = this.querySelector('[data-card-track]');
    const slides = [...track ? track.querySelectorAll('a') : []];
    const previous = this.querySelector('[data-card-prev]');
    const next = this.querySelector('[data-card-next]');
    if (!track || slides.length < 2 || !previous || !next) return;
    let startX = 0, startY = 0, startScroll = 0, dragged = false;
    track.addEventListener('pointerdown', event => { startX = event.clientX; startY = event.clientY; startScroll = track.scrollLeft; dragged = false; });
    track.addEventListener('pointermove', event => { if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) dragged = true; }, { passive: true });
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (event.detail !== 0 && (dragged || Math.abs(track.scrollLeft - startScroll) > 8)) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    const update = () => {
      const index = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
      previous.disabled = index <= 0;
      next.disabled = index >= slides.length - 1;
    };
    track.addEventListener('scroll', update, { passive: true });
    const move = step => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth) + step));
      track.scrollTo({ left: track.clientWidth * index, behavior: motionQuery.matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    new ResizeObserver(update).observe(track);
    update();
  }
}
customElements.define('card-carousel', CardCarousel);
(() => {
  const observed = new WeakSet();
  const styleRoot = root => {
    if (!root || observed.has(root)) return;
    observed.add(root);
    const style = document.createElement('style');
    style.textContent = '.activator{--activator-fg:#444!important;--activator-bg:#fff!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;border-radius:50%!important;background:#fff!important;color:#444!important;border:1px solid #dedede!important;box-shadow:0 1px 5px #0000000d!important}.activator{flex-direction:column!important;gap:2px!important}.activator::after{content:"Chat";display:block;font:400 10px/11px Arial,Helvetica,sans-serif;letter-spacing:0;text-transform:none;color:inherit;pointer-events:none}.activator__label{display:none!important}.activator__icon{display:block!important;flex:none!important;line-height:0!important}.activator__icon svg{width:19px!important;height:19px!important}';
    root.append(style);
    const check = () => {
      if (!style.isConnected) root.append(style);
      root.querySelectorAll('shopify-agent-runtime').forEach(runtime => styleRoot(runtime.shadowRoot));
    };
    new MutationObserver(check).observe(root, { childList: true, subtree: true });
    check();
  };
  const init = () => document.querySelectorAll('shopify-chat').forEach(chat => styleRoot(chat.shadowRoot));
  customElements.whenDefined('shopify-chat').then(init);
  customElements.whenDefined('shopify-agent-runtime').then(init);
  new MutationObserver(init).observe(document.body, { childList: true });
})();

(() => {
  const refineConsentPanel = (panel) => {
    if (!panel || panel.dataset.conceptAppearance === 'true') return;
    panel.dataset.conceptAppearance = 'true';
    const labels = {'raksha-accept':'Accept all','raksha-decline':'Essential only','raksha-manage':'Preferences'};
    Object.entries(labels).forEach(([id,label]) => {
      const button = panel.querySelector('#' + id);
      if (button) button.textContent = label;
    });
    ['width','max-width','bottom','right','padding','background-color','color','border','border-radius','box-shadow','font-family'].forEach(property => panel.style.removeProperty(property));
  };
  const start = () => {
    refineConsentPanel(document.getElementById('raksha-consent-banner'));
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.id === 'raksha-consent-banner') refineConsentPanel(node);
        else refineConsentPanel(node.querySelector('#raksha-consent-banner'));
      }));
    }).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

/* Optional paid handwriting service for greeting cards. */
(() => {
 const cardHandles = new Set(['bina-mas-bieu-mas-bon','danki-di-kurason','mi-stima-bo-un-mundu','masha-pabien-ruman-sigui-bria','masha-pabien-ii','masha-pabien-amor','masha-masha-pabien','masha-pabien-i','masha-pabien-amiga','pa-mi-amor','concept-statement-masha-pabien-dushi-pink','re']);
 const handle = location.pathname.split('/products/')[1]?.split('/')[0];
 if (!cardHandles.has(handle)) return;
 const form = document.querySelector('.main-product__form');
 if (!form) return;
 const button = form.querySelector('[data-add-button]');
 if (!button) return;
 const box = document.createElement('div');
 box.className = 'cs-handwritten';
 box.innerHTML = '<label style="display:flex;align-items:center;gap:10px;text-transform:none;letter-spacing:0;font-size:14px;font-weight:400;margin:0 0 12px"><input type="checkbox" data-message-opt-in> Add a handwritten message — €2.50 per card</label><div data-message-fields hidden><label for="CardHandwrittenMessage" style="text-transform:none;letter-spacing:0">Your message</label><textarea id="CardHandwrittenMessage" maxlength="250" rows="4" style="width:100%;padding:12px;border:1px solid #ccc;background:#fff" aria-describedby="CardMessageCount"></textarea><p id="CardMessageCount" style="font-size:12px;margin:4px 0 14px" aria-live="polite">0 / 250 characters</p></div><p data-message-error role="alert" hidden></p>';
 box.style.marginBottom = '16px';
 button.before(box);
 const opt = box.querySelector('[data-message-opt-in]'), fields = box.querySelector('[data-message-fields]'), input = box.querySelector('textarea'), count = box.querySelector('#CardMessageCount'), error = box.querySelector('[data-message-error]');
 const checkout = form.querySelector('[data-dynamic-checkout]');
 opt.addEventListener('change', () => {
   fields.hidden = !opt.checked; input.required = opt.checked;
   if(checkout) checkout.hidden = opt.checked;
   if(opt.checked) input.focus();
 });
 input.addEventListener('input', () => { count.textContent = input.value.length + ' / 250 characters'; input.setCustomValidity(''); });
 let busy = false;
 form.addEventListener('submit', async event => {
   if (!opt.checked) return;
   event.preventDefault(); event.stopImmediatePropagation();
   if (busy) return;
   input.setCustomValidity(input.value.trim() ? '' : 'Please enter your message.');
   if (!form.reportValidity()) return;
   const data = new FormData(form), variant = data.get('id'), quantity = Number(data.get('quantity') || 1);
   if (!variant || !Number.isInteger(quantity) || quantity < 1) return;
   busy = true; button.disabled = true; error.hidden = true;
   try {
     const root = window.Shopify?.routes?.root || '/';
     const response = await fetch(root + 'cart/add.js', {
       method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
       body:JSON.stringify({items:[
         {id:Number(variant),quantity},
         {id:55067019837773,quantity,properties:{'For card':document.querySelector('.main-product__info h1')?.textContent.trim() || handle,'Message':input.value.trim(),'Card variant':String(variant)}}
       ]})
     });
     const result = await response.json();
     if (!response.ok) throw new Error(result.description || 'We could not add your card. Please check your basket before trying again.');
     location.assign(root + 'cart');
   } catch (err) {
     error.textContent = err.message || 'Please check your basket before trying again.'; error.hidden = false;
     busy = false; button.disabled = false;
   }
 },true);
})();

/* Select the items belonging to each wrapped gift before checkout. */
(async () => {
 const container=document.querySelector('.main-cart'), form=container?.querySelector('form');
 if(!form)return;
 const root=window.Shopify?.routes?.root||'/', wrapId=38179049406657, messageId=55067019837773;
 const checkout=form.querySelector('[name="checkout"]'), summary=form.querySelector('.main-cart__summary');
 const request=async(path,body)=>{
   const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{headers:{Accept:'application/json'}});
   const data=await response.json();
   if(!response.ok)throw Error(data.description||'Unable to save. Please check your bag and try again.');
   return data;
 };
 try{
 const cart=await request('cart.js');
 const lines=[...form.querySelectorAll('.main-cart__line')];
 cart.items.forEach((item,i)=>{
   const detail=lines[i]?.querySelector('h2')?.parentElement;
   if(detail)Object.entries(item.properties||{}).filter(([key,value])=>!key.startsWith('_')&&value&&key!=='Card variant').forEach(([key,value])=>{
     const p=document.createElement('p');p.textContent=key+': '+value;detail.append(p);
   });
 });
 const units=cart.items.filter(item=>item.variant_id!==wrapId&&item.variant_id!==messageId&&!item.gift_card).flatMap(item=>Array.from({length:item.quantity},(_,i)=>({key:item.key+'#'+i,title:item.product_title+(item.variant_title&&item.variant_title!=='Default Title'?' — '+item.variant_title:'')+(item.quantity>1?' (item '+(i+1)+')':'')})));
 if(!units.length)return;
 const existing=cart.items.filter(item=>item.variant_id===wrapId);
 const panel=document.createElement('section');panel.style.cssText='border-top:1px solid #ddd;padding:24px 0;margin:24px 0';
 const heading=document.createElement('h2');heading.textContent='Make it a gift';heading.style.cssText='font:400 18px/1.4 Arial,sans-serif;margin:0 0 10px';
 const intro=document.createElement('p');intro.textContent='€4 per wrapped gift, including an optional handwritten note. Select the same gift number for pieces you want wrapped together.';intro.style.cssText='font-size:14px;line-height:1.5';
 panel.append(heading,intro);
 const selections=new Map(), messages=new Map();
 existing.forEach((item,i)=>{
   let saved=[];try{saved=JSON.parse(item.properties?._gift_units||'[]');}catch{}
   const group=String(i+1);saved.forEach(key=>selections.set(key,group));messages.set(group,item.properties?.Message||'');
 });
 let dirty=false,busy=false, quantitiesChanged=false;
 const markDirty=()=>{dirty=true;status.textContent='Save your gift-wrapping choices before checkout.';};
 const selectors=[];
 units.forEach((unit,i)=>{
   const label=document.createElement('label');label.style.cssText='display:block;font-size:14px;margin:16px 0 6px';label.htmlFor='GiftGroup-'+i;label.textContent=unit.title;
   const select=document.createElement('select');select.id=label.htmlFor;select.style.cssText='width:100%;padding:10px;border:1px solid #ccc;background:white';
   const none=document.createElement('option');none.value='';none.textContent='No gift wrapping';select.append(none);
   units.forEach((_,n)=>{const option=document.createElement('option');option.value=String(n+1);option.textContent='Gift '+(n+1);select.append(option);});
   select.value=selections.get(unit.key)||'';selectors.push({unit,select});select.addEventListener('change',()=>{renderNotes();markDirty();});panel.append(label,select);
 });
 const noteArea=document.createElement('div');panel.append(noteArea);
 const total=document.createElement('p');total.style.fontSize='14px';panel.append(total);
 const renderNotes=()=>{
   noteArea.querySelectorAll('textarea').forEach(input=>messages.set(input.dataset.group,input.value));
   noteArea.replaceChildren();
   const groups=[...new Set(selectors.map(x=>x.select.value).filter(Boolean))].sort((a,b)=>Number(a)-Number(b));
   groups.forEach(group=>{
     const label=document.createElement('label');label.htmlFor='GiftMessage-'+group;label.textContent='Gift '+group+' — optional message';label.style.cssText='display:block;font-size:14px;margin:16px 0 6px';
     const input=document.createElement('textarea');input.id=label.htmlFor;input.dataset.group=group;input.maxLength=250;input.rows=3;input.value=messages.get(group)||'';input.style.cssText='width:100%;padding:10px;border:1px solid #ccc;background:white';
     const count=document.createElement('small');count.textContent=input.value.length+' / 250 characters';
     input.addEventListener('input',()=>{count.textContent=input.value.length+' / 250 characters';markDirty();});
     noteArea.append(label,input,count);
   });
   total.textContent=groups.length+' wrapped gift'+(groups.length===1?'':'s')+' — '+new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart.currency||'EUR'}).format(groups.length*4);
 };
 const save=document.createElement('button');save.type='button';save.className='button';save.textContent='Save gift wrapping';save.style.marginTop='14px';
 const status=document.createElement('p');status.setAttribute('role','status');status.style.fontSize='13px';panel.append(save,status);summary.before(panel);
 const update=document.createElement('button');update.type='submit';update.name='update';update.className='button';update.textContent='Update bag';update.style.marginBottom='12px';checkout.before(update);
 form.querySelectorAll('[name="updates[]"]').forEach(input=>input.addEventListener('change',()=>{quantitiesChanged=true;status.textContent='Select “Update bag” first, then choose your wrapping.';}));
 form.addEventListener('submit',event=>{if(event.submitter===checkout&&(dirty||busy)){event.preventDefault();status.textContent='Please save your gift wrapping before checkout.';save.focus();}});
 renderNotes();
 const validKeys=new Set(units.map(x=>x.key));
 if(existing.some(item=>{try{return JSON.parse(item.properties?._gift_units||'[]').some(key=>!validKeys.has(key));}catch{return true;}})){markDirty();}
 save.addEventListener('click',async()=>{
   if(busy)return;
   if(quantitiesChanged){status.textContent='Select “Update bag” first, then choose your wrapping.';update.focus();return;}
   renderNotes();
   const groups=[...new Set(selectors.map(x=>x.select.value).filter(Boolean))];
   const items=groups.map(group=>{const selected=selectors.filter(x=>x.select.value===group);return{id:wrapId,quantity:1,properties:{Gift:'Gift '+group,Items:selected.map(x=>x.unit.title).join('; '),Message:messages.get(group)||'',_gift_units:JSON.stringify(selected.map(x=>x.unit.key))}};});
   busy=true;save.disabled=true;checkout.disabled=true;status.textContent='Saving…';
   try{
     if(existing.length)await request('cart/update.js',{updates:Object.fromEntries(existing.map(item=>[item.key,0]))});
     if(items.length)await request('cart/add.js',{items});
     dirty=false;location.reload();
   }catch(error){status.textContent=error.message;dirty=true;busy=false;save.disabled=false;checkout.disabled=false;}
 });
 }catch(error){console.error('Gift wrapping could not load',error);}
})();


